import { httpClient } from '@/lib/api';

import type { RequirementImport, RequirementUploadResult } from '../types';

/**
 * Délai d'envoi des fichiers.
 *
 * Plus long que les 20 s par défaut du client : la requête ne fait que déposer
 * les fichiers — l'analyse, elle, est asynchrone — mais plusieurs cahiers des
 * charges sur une connexion montante modeste prennent facilement plus de vingt
 * secondes.
 */
const UPLOAD_TIMEOUT_MS = 120_000;

export const requirementImportsApi = {
  summary: () =>
    httpClient.get<{ counts: Record<RequirementImport['status'], number> }>(
      '/requirement-imports/summary',
    ),
  list: (filters: {
    page: number;
    limit: number;
    q?: string;
    status?: RequirementImport['status'];
  }) =>
    httpClient.getPaginated<RequirementImport>('/requirement-imports', { query: { ...filters } }),
  assign: (
    id: string,
    assignments: {
      index: number;
      companyId: string;
      contactId: string;
      projectId?: string | null;
    }[],
  ) =>
    httpClient.post<RequirementImport>('/requirement-imports/' + id + '/assign', { assignments }),
  /**
   * `POST /requirement-imports` — dépose un à cinq cahiers des charges.
   *
   * Le nom de champ `files` est imposé par le serveur (`multer.array('files')`).
   * Aucun `Content-Type` n'est posé : le navigateur doit générer lui-même la
   * frontière multipart, et la fixer à la main casserait l'envoi.
   */
  upload: (files: File[]): Promise<RequirementUploadResult> => {
    const form = new FormData();
    for (const file of files) form.append('files', file);

    return httpClient.post<RequirementUploadResult>('/requirement-imports', form, {
      timeoutMs: UPLOAD_TIMEOUT_MS,
    });
  },

  /** `GET /requirement-imports/:id` — avancement d'un dépôt. */
  getById: (id: string): Promise<RequirementImport> =>
    httpClient.get<RequirementImport>(`/requirement-imports/${id}`),
};
